import { environment } from '../../../environments/environment'

export enum MbConstants {
  TITLE = 'Title',
  ACADEMIC_DEGREE = 'Academic degree',
  ROLE = 'Role',
  NG_DROPDOWN_TOGGLE = 'ngbdropdowntoggle',
  NG_MODEL_ATTRIBUTE = 'ng-reflect-model',
  INPUT = 'INPUT',
  TEXTAREA = 'TEXTAREA',
  BUTTON = 'BUTTON',
  SESSION_WIZARD_KEY = 'registration-wizard',
  HIGHLIGHT_LABEL = 'HIGHLIGHT',
  NEW_LABEL = 'NEW',
  FINAL_STOCK_LABEL = 'FINAL STOCK',
  COLON_SYMBOL = ':',
  EQUAL_SYMBOL = '=',
  HASH_SYMBOL = '#',
  PLUS_SYMBOL = '+',
  TITLE_CODE = 'title',
  ACADEMIC_DEGREE_CODE = 'academicDegree',
  FIRST_NAME_CODE = 'firstName',
  LAST_NAME_CODE = 'lastName',
  EMAIL_CODE = 'email',
  PHONE_NUMBER_CODE = 'phoneNumber',
  JOB_TITLE_CODE = 'jobTitle',
  CUSTOMER_NUMBER_CODE = 'customerNumber',
  FALLBACK_LANGUAGE = 'en',
  FALLBACK_COUNTRY = 'UN',
  FALLBACK_CURRENCY = 'USD',
  INSTITUTE_CODE = 'institute',
  DEPARTMENT_CODE = 'department',
  BUILDING_CODE = 'building',
  LAB_CODE = 'lab',
  ZIP_CODE_CODE = 'zipcode',
  CITY_CODE = 'city',
  TOWN_CODE = 'town',
  COUNTRY_CODE = 'country',
  VAT_ID_CODE = 'vatId',
  COMPANY_CODE = 'companyName',
  STREET_CODE = 'street',
  HOUSE_NO_CODE = 'houseNo',
  ZIP_CODE = 'zipCode',
  REGION_CODE = 'region',
  SALES_TAX_EXEMPT_CODE = 'taxExempt',
  PO_FILE_CODE = 'poFile',
  FILE_CODE = 'file',
  COUNTRY = 'Country',
  STATE = 'State',
  INVOICE_CODE = 'invoice',
  CREDIT_CARD_CODE = 'ingenicoCardPaymentMode',
  PLACEHOLDER_PAYMENT_MODE_CODE = 'miltenyi-webshop-placeholder-payment-mode',
  BILLING_ADDRESS_CODE = 'billingAddress',
  PAYMENT_MODE_SELECTION = 'paymentModeSelection',
  PO_NUMBER_CODE = 'poNumber',
  STATE_CODE = 'state',
  STREET_INFORMATION = 'streetInformation',
  POSTAL_CODE_CODE = 'postalCode',
  CHECKOUT_NOTES_CODE = 'checkoutNotes',
  ID_LOWER_CASE = 'id',
  CHECKOUT = 'checkout',
  TERMS_OF_USE = 'termsOfUse',
  TERMS_AND_CONDITIONS = 'termsAndConditions',
  PRICE_REQUEST = 'PRICE_REQUEST',
  PRICE_MIX = 'PRICE_MIX',
  PRICE_AVAILABLE = 'PRICE_AVAILABLE',
  THUMBNAIL_FORMAT = 'thumbnail',
  HIGH_RESOLUTION_FORMAT = '360p',
  CAMPUS_MODAL_TEMPLATE = 'miltenyi_university_modal',
  MILTENYI_UNIVERSITY_HOME_PAGE_SEO = 'miltenyi-university.html',
  ALL_PRODUCT_CATEGORIES_URL = '/all-product-categories.html',
  NEWSLETTER_PREFERENCES = 'newsletter-preferences.html',
  CAMPUS_MODAL_COOKIE = 'showCampusModal',
  ALL_CATEGORIES = 'allCategories',
  ALL_CATEGORIES_OR = 'allCategoriesOR',
  CATEGORY_FACET_CODE = 'Category',
  CATEGORY_OR_FACET_CODE = 'CategoryOR',
  CODE_STRING = 'codeString',
  MB_PDP_URL_SUFFIX = '.html',
  INTERNATIONAL = 'International',
  COLON_RELEVANCE = ':relevance',
  RELEVANCE = 'relevance',
  URL_QUERY = '?query',
  CONTACT_BOX_FULL = 'contact_box_navigation',
  CONTACT_BOX_IN_CART = 'contact_box_in_cart',
  CONTACT_BOX_IN_MY_ACCOUNT = 'contact_box_in_my_account',
  CART_MIGRATION_SPARTACUS_KEY = 'spartacus⚿',
  CART_MIGRATION_KEY = '⚿cart',
  MB_BASE_SITE_NO_COUNTRY_KEY = 'miltenyiWebshop',
  MB_FALLBACK_BASE_SITE = 'miltenyiWebshopUN',
  SLASH_PRODUCTS_URL = '/products/',
  PAGE_TITLE_MILTENYI_SUFFIX = 'Miltenyi Biotec',
  PRODUCT_DETAILS_PAGE_ID = 'productDetails',
  SEARCH_PAGE_ID = 'search',
  COUNTRY_REDIRECT = 'countryRedirect=1',
  ADDRESS_NOT_VERIFIED_STATUS_01 = '01',
  ADDRESS_IN_VERIFICATION_STATUS_02 = '02',
  ADDRESS_VERIFIED_APPROVED_STATUS_03 = '03',
  ADDRESS_VERIFIED_REJECTED_STATUS_04 = '04',
  MB_SPINNER = 'MB_SPINNER',
  CHECKOUT_CONFIRMATION_PAGE = 'checkout/confirmation',
  CHECKOUT_REVIEW_PAGE = 'checkout/review',
  MY_ACCOUNT_ORDER_PAGE = 'myaccount/order',
  CHECKOUT_STEP_LOGIN = 'login',
  REDIRECT_URL_COOKIE = 'redirectUrl',
  DESCRIPTION = 'description',
  KEYWORDS = 'keywords',
  SAP_OUTBOUND_ID = 'sap-outbound-id',
  CAMPAIGN_SECURITY_TOKEN = 'campaign-security-token',
  VIDEO_LIBRARY_CHANNEL_PARAM = 'currentChannelId',
  VIDEO_LIBRARY_VIDEO_PARAM = 'currentVideoId',
  PDF_EXTENSION = 'pdf',
  PLACE_ORDER_STATUS_SUCCESS = 'SUCCESS',
  PLACE_ORDER_STATUS_CANCELLED = 'CANCELLED',
  COA = 'CoA',
  CCN = 'CCN',
  PRIVACY_STATEMENT_FOR_CANDIDATES = 'privacy-statement-for-candidates.html',
  QUERY_CONTENT_PARAM = 'queryContent',
  QUERY_JOB_PARAM = 'queryJob',
  QUERY_PARAM = 'query',
  FILTER_CONTENT = 'filterContent',
  FILTER_CERT = 'filterCert',
  FILTER_CCN = 'filterCCN',
  FILTER_VIDEO = 'filterVideo',
  FILTER_JOB = 'filterJob',
  FILTER_DOCUMENT = 'filterDocument',
  SEARCH_CONTENT = 'searchContent',
  SEARCH_CERT = 'searchCert',
  SEARCH_CCN = 'searchCCN',
  SEARCH_VIDEO = 'searchVideo',
  SEARCH_JOB = 'searchJob',
  SEARCH_DOCUMENT = 'searchDocument',
  SEARCH_FILTER_PARAM = 'searchFilter',
  SEARCH_PARAM = 'search',
  LIST_PARAM = 'list',
  JOBS_AUTOCOMPLETE_FIELD = 'title_keyword_lc',
  HAS_SEARCHBOX_RESULTS_CLASS = 'has-searchbox-results',
  SEARCHBOX_IS_ACTIVE_CLASS = 'searchbox-is-active',
  CART_PAGE_URL = '/cart',
  PO_UPLOAD_SUCCESS = 'success',
  PO_UPLOAD_FAILED = 'failed',
  PO_UPLOAD_URL = '/purchase-order-upload',
  RELATED = 'RELATED',
  CORPORATE_ORANGE = 'corporate-orange',
  PRODUCTS = 'Products',
  APPLICATIONS = 'Applications',
  SEARCH_CLOSE = 'searchClose',
  MACS_HANDBOOKS = 'macs_handbooks',
  HANDBOOK_FIRST_LEVEL = 'handbook_first_level',
  HANDBOOK_SECOND_LEVEL = 'handbook_second_level',
  HANDBOOK_THIRD_LEVEL = 'handbook_third_level',
  COLOR_CONTAINER_RELATED_ITEMS = 'color_container_related_items',
  CALL_TO_ACTION_BUTTON = 'call_to_action_button',
  COLOR_CONTAINER_CONTENT_TEXT = 'color_container_content_text',
  HIGHLIGHT = 'Highlight',
  SPECIAL_OFFER = 'special-offer',
  TIMELINE = 'time_line',
  CONTENT_TYPE = 'Content Type',
  AUTOCOMPLETE = 'autocomplete',
  COLLAPSED = 'collapsed',
  EXPANDED = 'expanded',
  OAUTH_REDIRECT_FLOW_KEY = 'oAuthRedirectCodeFlow',
  UC_ID = 'uc-id',
  UC_SERVICE = 'uc-service',
  UC_SERVICE_BLOCK_CLASS = 'uc-blocked',
  UC_SERVICE_BLOCK_LINK_CLASS = 'uc-link-blocked',
  UC_CHAT_ACCEPT_BUTTON = 'open chat',
  UC_MI_ACCEPT_BUTTON = 'load video',
  UC_DEFAULT_ACCEPT_BUTTON = 'load',
  UNDEFINED = 'undefined',
  NAVIGATION = 'navigation',
  FOOTER_NAVI = 'FooterNavi',
  MERGE = 'merge',
  COPY_SKU = 'CopySKU',
  PRODUCT_SKU = 'productSKU',
  PRODUCT_TITLE = 'product-title',
  DATA_ANALYTICS = 'data-analytics',
  COPY_ORDER_NUMBER = 'Copy Order Number',
  COPY_PRODUCT_IDENTIFIER ='Copy Product Identifier',
}

export enum DataAnalyticsClickSource {
  CART_OVERLAY = 'Cart Overlay',
  LIST = 'List',
  ORDER_HISTORY = 'Order History',
  PDP = 'PDP',
  PDP_CROSS_SELLING = 'PDP Cross Selling',
  QUICK_ADD = 'Quick Add',
  RECOMMENDED_PRODUCTS_CART = 'Recommended Products Cart',
  UNKNOWN = 'UNKNOWN',
  WISHLIST = 'Wishlist'
}

export enum DataAnalyticsEventLabel {
  QUICK_ADD = 'Quick add',
  ORDER_HISTORY = 'Order history',
  ADD_TO_CART = 'Add to cart',
  REQUEST_PRICE = 'Request Price',
  UNKNOWN = 'UNKNOWN'
}

export const classificationCodes = {
  abHeader: environment.classificationCodes.abHeader,
  sizeFilter: environment.classificationCodes.sizeFilter,
  stamps: environment.classificationCodes.stamps,
  stampRecombinantCode: environment.classificationCodes.stampRecombinant,
  stampExtendedValidationCode: environment.classificationCodes.stampExtendedValidation,
  prov: environment.classificationCodes.prov,
  orderInformation: environment.classificationCodes.orderInformationCode,
  orderInformationAlternativeNames: environment.classificationCodes.alterNativeNames
}

export const checkoutValidationRules = {
  checkoutStringMaxLength: 35
}

export const productFilterOption = {
  filterLength: 10
}

export const poUploadMaxFileSize: number = 10485760

export const orderHistoryPageSize: number = 5

export const placeholderImage: string = '../../../../../assets/images/fallback-image-1250x1250.png'

export const searchTermCharLimit: number = 50

export const maxQuantityFallback: number = 30

export const maxRelatedProducts: number = 5
